//@flow
import GlobalData from './globalData';

const SHIPPING_METHODS = [
  {
    title: "Standard 5-7 business days,",
    value: "checkout_checkout",
  },
  {
    title: "2-Day 2 business days,",
    value: "checkout_express",
  },
];

const SHIPPING_VALUES = {
  "checkout_checkout": {
    name: "Standard",
    time: "Shipping",
    min: 5,
    max: 7,
    price: 'Free',
  },
  "checkout_express": {
    name: "2-Day",
    time: "(2 business days)",
    min: 1,
    max: 2,
    price: "$6.95",
  },
};


export default {
  SHIPPING_METHODS,
  SHIPPING_VALUES,

  ipIsInCA():boolean {
    // naturebox.userCountry is set by the express server based on Cloudflare headers
    return GlobalData.getBool('userCountry') === 'CA';
  },
};
